<template>
  <span :class="printClassName" v-html="printMarked" />
</template>

<script>
export default {
  name: 'm-mark',
  props: [ 'className', 'match', 'text' ],
  computed: {
    printMarked () {
      const { match, text } = this.$props
      return text ? (match ? text.replace(new RegExp(match, 'g'), `<mark>${match}</mark>`) : text) : ''
    },
    printClassName () {
      return this.$props.className || ''
    }
  }
}
</script>